import type { IMessageBase } from './base';

export const MESSAGE_TYPE = 'ADDROUTE_HEADERAPPEND';

export interface IMessageHeaderAppendResponderPayload extends IMessageBase {
    type: 'ADDROUTE_HEADERAPPEND';
    payload: {
        matcher: string;
        key: string;
        val: string;
        expiration: number;
    };
}
